import { useTranslation } from 'react-i18next';
import Button from '@/ui/atoms/Button';

// NextActionCta — small post-Report CTA pair: primary "find your next
// question" + secondary "save report".
interface NextActionCtaProps {
  onPrimary: () => void;
  onSecondary: () => void;
  primaryDisabled?: boolean;
  secondaryDisabled?: boolean;
}

export function NextActionCta({
  onPrimary,
  onSecondary,
  primaryDisabled,
  secondaryDisabled,
}: NextActionCtaProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap gap-3" data-testid="next-action-cta">
      <Button variant="vermilion" onClick={onPrimary} disabled={primaryDisabled}>
        {t('firstWin.nextActionPrimary')}
      </Button>
      <Button variant="secondary" onClick={onSecondary} disabled={secondaryDisabled}>
        {t('firstWin.nextActionSecondary')}
      </Button>
    </div>
  );
}

export default NextActionCta;
